import React, { useEffect, useState } from 'react'
import { Button, Col, Row, Table } from 'react-bootstrap'
import { getWorksAPI, getWorksHaveAPI } from '../../../services/history-works'
import { BsPlusLg } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import CheckUserAdmin from '../../../helper/check-user-admin'
import CreateWorkHistory from '../../employees/pim-detail/work-history-create'
import EditWorkHistory from '../../employees/pim-detail/work-history-edit'
import FileWorkHistoryTable from './file-work-table'
import { FaCircleCheck } from 'react-icons/fa6'
import Autocomplete from '../../custom/autocomplete'
import { useDebounce } from '@react-hook/debounce'
import { RecruitsWorksAPI } from '../../../services/recruit'
import UserecruitsAePersonal from '../../../hooks/use-recruit-ae-personal'
import ModalAddAEWork from './modal-add-ae-work'
import { v4 as uuidv4 } from 'uuid'

function ProfileWorkHistory() {
  const profile = useSelector((state) => state.loginReducer.profile)
  const orgId = profile.org_id
  const code = profile.code
  const [dataTable, setDataTable] = useState([])
  const [showCreate, setShowCreate] = useState(false)
  const [showEdite, setShowEdite] = useState(false)
  const [isSave, setIsSave] = useState(false)
  const [onStatus, setOnStatus] = useState(false)
  const [detailTable, setDetailTable] = useState()
  const [have, setHave] = useState([])
  const [showAE, setShowAE] = useState(false)
  const [dataAe, setDataAe] = useState([])
  const [searchAE, setSearchAE] = useDebounce('', 1000)
  const codeAE = UserecruitsAePersonal(searchAE, code, orgId)

  useEffect(() => {
    if (orgId && code) {
      fnGetWorks()
    }
  }, [orgId, code, onStatus])

  const roleId = useSelector((state) => state.roleReducer.role)
  const profileId = useSelector((state) => state.loginReducer.profile)
  const roles = CheckUserAdmin(profileId.roles, roleId)

  const fnSearchAE = async (aeNo) => {
    const param = {
      aeNo,
      orgId
    }
    const resp = await RecruitsWorksAPI(param)
    if (!resp) return
    if (resp.status) {
      const newTable =
        resp.result.length > 0
          ? resp.result.map((d) => {
              return {
                id: uuidv4(),
                company: d.company,
                isCompany: !!d.company,
                histyPosition: d.histyPosition,
                isHistoryPosition: !!d.histyPosition,
                duty: d.duty,
                isDuty: !!d.duty,
                fromYear: d.fromYear,
                isFromYear: !!d.fromYear,
                toYear: d.toYear,
                isToYear: !!d.toYear,
                histyReason: d.histyReason,
                isHistoryReason: !!d.histyReason
              }
            })
          : []
      setDataAe(newTable)
      setShowAE(true)
    }
  }

  const fnGetWorks = async () => {
    const result = await getWorksAPI({ orgId, code })
    if (!result) return
    if (result.status) {
      setDataTable(result.result)
    }
    getWorksHave()
  }

  const getWorksHave = async () => {
    const param = { orgId, code }
    const res = await getWorksHaveAPI(param)
    if (!res) return
    if (res.status) {
      setHave(res.result)
    }
  }
  return (
    <Row>
      <Col xl={12} className="d-flex justify-content-between mb-3">
        <div className="d-flex justify-content-start">
          {' '}
          <span className="my-auto text-primary me-2">Work History</span>
          {have?.status_id === 0 ? (
            <div className="text-success mt-1">
              <span className="me-1">
                {' '}
                <FaCircleCheck />{' '}
              </span>
              <span className="small">{have?.status_name}</span>
            </div>
          ) : (
            <span className="text-secondary small pt-2">
              (หากมีประสบการณ์ทำงานมากกว่า 1 บริษัท กรุณากรอกอย่างน้อย 2
              บริษัทล่าสุด)
            </span>
          )}
        </div>

        <div className="d-flex justify-content-end">
          {/* {have?.status_id === 0 ? (
            <></>
          ) : ( */}
          <div className="d-flex">
            <div style={{ minWidth: 200 }} className="me-3">
              <Autocomplete
                isClearable={true}
                height={'32px'}
                placeholder={'Search AE No.'}
                options={codeAE}
                onInputChange={(data) => {
                  setSearchAE(data.toUpperCase())
                }}
                onChange={(data) => {
                  if (data) {
                    fnSearchAE(data.value)
                  }
                }}
              />
            </div>

            <Button
              className="px-4"
              size="sm"
              onClick={() => setShowCreate(true)}
            >
              <BsPlusLg /> Add Work History
            </Button>
          </div>
          {/* )} */}
        </div>
      </Col>
      <Col className="">
        <Table responsive bordered hover className="mb-0">
          <thead
            className="bg-hrms text-white "
            style={{ position: 'sticky', top: '0px' }}
          >
            <tr>
              <th
                className="fw-normal small align-middle text-center"
                rowSpan={2}
              >
                #
              </th>
              <th className="fw-normal small align-middle " rowSpan={2}>
                Company Name
              </th>
              <th className="fw-normal small align-middle " rowSpan={2}>
                Position
              </th>
              <th className="fw-normal small align-middle " rowSpan={2}>
                Job description
              </th>
              <th
                className="fw-normal small align-middle text-center"
                colSpan={2}
              >
                Periods
              </th>

              <th className="fw-normal small align-middle " rowSpan={2}>
                Reason for leaving
              </th>

              {/* <th className="fw-normal small align-middle text-center" rowSpan={2}>
                View
              </th> */}
              <th
                className="fw-normal small align-middle text-center"
                rowSpan={2}
              >
                <div className="fw-normal ">File </div>
                <div className="fw-light small align-middle ">
                  (PDF Max 8 MB)
                </div>
              </th>
              <th
                className="fw-normal small align-middle text-center"
                rowSpan={2}
              >
                Edit
              </th>
            </tr>
            <tr>
              <th className="fw-normal small align-middle text-center">From</th>
              <th className="fw-normal small align-middle text-center">To</th>
            </tr>
          </thead>
          <tbody>
            {dataTable.length > 0 ? (
              dataTable.map((d, i) => (
                <FileWorkHistoryTable
                  keys={i}
                  detail={d}
                  fnData={fnGetWorks}
                  isFile={d.isFile}
                  setShowEdite={setShowEdite}
                  showEdite={showEdite}
                  roles={roles}
                  setDetailTable={setDetailTable}
                />
              ))
            ) : (
              <tr className="fw-light ">
                <td colSpan={9} className="text-center">
                  - No data -
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>

      {showCreate && (
        <CreateWorkHistory
          have={have}
          param={{ orgId, code }}
          setIsSave={setIsSave}
          showCreate={showCreate}
          isSave={isSave}
          fnGetWorks={fnGetWorks}
          setShowCreate={setShowCreate}
          setOnStatus={setOnStatus}
          onStatus={onStatus}
        />
      )}
      {showEdite && (
        <EditWorkHistory
          detail={detailTable}
          param={{ orgId, code }}
          setIsSave={setIsSave}
          showCreate={showEdite}
          isSave={isSave}
          fnGetWorks={fnGetWorks}
          setShowCreate={setShowEdite}
        />
      )}
      {showAE && (
        <ModalAddAEWork
          setIsSave={setIsSave}
          have={have}
          isSave={isSave}
          showAE={showAE}
          setShowAE={setShowAE}
          dataAe={dataAe}
          setDataAe={setDataAe}
          orgId={orgId}
          code={code}
          fnGetWorks={fnGetWorks}
        />
      )}
    </Row>
  )
}

export default ProfileWorkHistory
